/*
  Plays popup video which has a video file
*/

export function videoPopupPlayerFile() {
  // var videoSrc;
  // var videoControls;
  // $('.video-iframe-thumbnail.video-file').click(function () {
  //   videoSrc = $(this).data('src');
  //   videoControls = $(this).data('controls');
  //   console.log(videoSrc);
  // });

  // $('#myModal-video-file.video-file').on('shown.bs.modal', function () {
  //   console.log(videoSrc);
  //   $('#myModal-video-file #video').attr(
  //     'src',
  //     videoSrc + '?autoplay=1&mute=1&amp&modestbranding=1&amp&'+ videoControls+'&showinfo=0;'
  //   );
  // });

  // $('#myModal-video-file').on('hide.bs.modal', function () {
  //   $('#myModal-video-file #video').attr('src', '');
  // });

  $('.video-section.v2.file').each(function(index) {
    const modal = $(this).find('.modal');
    let videoOverlay = $(this).find('.video-overlay');

    const modalId = 'myModal-video-file-' + index;
    modal.attr('id', modalId);
    videoOverlay.attr('data-target', '#' + modalId);

    var video;
    var videoControls;

    videoOverlay.on('click', function() {
      video = $(this).siblings('.video-thumb').data('src');
      videoControls = $(this).siblings('.video-thumb').data('controls') || '';
    });

    modal.on('shown.bs.modal', function () {
      if (video) {
        modal.find('#video').attr(
          'src',
          video + '?autoplay=1&muted=1&modestbranding=1&' + videoControls + '&showinfo=0'
        );
      }
    });

    modal.on('hide.bs.modal', function () {
       modal.find('#video').attr('src', '');
    });
  });
}